import {
  ICreateRemittanceCreditMemoParams,
  ICreateRemittanceCreditMemoRepository,
  ICreateRemittanceCreditMemoRepositoryResponse,
} from "@/core/repositories/accounting";

export class CreateRemittanceCreditMemoUseCase {
  constructor(private readonly repository: ICreateRemittanceCreditMemoRepository) {}

  async execute(params: ICreateRemittanceCreditMemoParams): Promise<ICreateRemittanceCreditMemoRepositoryResponse> {
    return this.repository.createRemittanceCreditMemo(params);
  }
}
